<template>
  <div class="div">
      <!-- <footer >
      <p class="ms-3">©Copyright 2021. Tous droits reversés.</p>
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'Footer',
 
}
</script>
<style src="./footer.scss" lang="scss" scoped/>